export default __webpack_public_path__ + "static/media/warning.30cb642a.png";